import { render, staticRenderFns } from "./showIndex.vue?vue&type=template&id=98168694&"
import script from "./showIndex.vue?vue&type=script&lang=js&"
export * from "./showIndex.vue?vue&type=script&lang=js&"
import style0 from "./showIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/show/showIndex.vue
// module id = null
// module chunks = 